import { Controller } from "stimulus";

export default class extends Controller {
  openAll() {
    this.element.querySelectorAll("a").forEach(link => {
      window.open(link.href, "_blank");
    });
  }
}
